module.exports = __webpack_public_path__ + "static/media/28.cdab1948.png";